
import SkeletonMap from "../../components/skeleton/Map.vue";
import FrameService from "../../src/FrameService";
import { CupertinoPane } from "cupertino-pane";
import MapPage from "../../components/map/index.vue";
import MapPageList from "./components/MapPageList.vue";
import { Api } from "../../src/Api";
import PreviewCard from "../../components/Card/PreviewCard/index.vue";
import { Category } from "modules/spravochnik/dt-front-page-generator/src/Entity/Category";

export default {
    props: {
        categoryUrlName: {
            type: String,
            required: true,
        },
    },
    components: {
        SkeletonMap,
        MapPage,
        MapPageList,
        PreviewCard,
    },
    computed: {
        category(): Category {
            return this.$store.getters["category/category"];
        },
    },
    created() {
        (new FrameService()).offFooter().off();
        window.removeEventListener("resize", (e) => {
        });
        window.addEventListener("resize", (e) => {
            this.checkSizeWindow();
        });
    },
    async mounted() {
        this.loading = true;
        await Promise.all([
            this.loadCategory(),
            this.loadCategoryPageItems(),
        ]);
        this.loading = false;
        await this.$nextTick(this.checkSizeWindow);
    },
    methods: {
        async loadCategory(): Promise<void> {
            await this.$store.dispatch("category/loadCategory", this.categoryUrlName);
        },
        async loadCategoryPageItems() {
            const categoryMap = await Api.getAjaxCategoryMap(this.categoryUrlName);
            this.objects = categoryMap.objects;
        },
        async onChoiceElem(ids: string[]): Promise<void> {
            this.loadingItem = true;
            this.visibleCard = true;
            await this.$nextTick(async () => {
                await this.checkSizeWindow();
                this.items = await Api.fetchAllPageItemsForCategory(this.categoryUrlName, ids);
                this.loadingItem = false;
            });
        },
        onHideItems(): void {
            this.visibleCard = false;
            this.items = [];
            this.destroyJsPanelItems();
        },

        onOpenSearchCategory(): void {
            if (this.jsContentPanel) {
                this.jsContentPanel.moveToBreak("top");
            }
        },
        async checkSizeWindow() {
            if (window.innerWidth < 768) {
                await this.initJsPanel();
                await this.initJsPanelItems();
            } else {
                this.destroyJsPanel();
                this.destroyJsPanelItems();
            }
        },
        async initJsPanel() {
            if (this.jsContentPanel === null) {
                this.jsContentPanel = new CupertinoPane(this.$refs.jsContentPanel, this.settings);
                await this.jsContentPanel.present({ animate: true });
            }
        },
        async initJsPanelItems() {
            if (this.jsContentPanelItems === null && (this.loadingItem === true || this.items.length > 0)) {
                this.jsContentPanelItems = new CupertinoPane(this.$refs.jsItemsPanel, this.settings);
                await this.jsContentPanelItems.present({ animate: true });
                this.jsContentPanelItems.moveToBreak("top");
            }
        },
        destroyJsPanel() {
            if (this.jsContentPanel) {
                this.jsContentPanel.destroyResets();
                this.$refs.jsContentPanel.removeAttribute("style");
                this.jsContentPanel = null;
            }
        },
        destroyJsPanelItems() {
            if (this.jsContentPanelItems) {
                this.jsContentPanelItems.destroyResets();
                this.jsContentPanelItems = null;
            }
        },
    },
    data() {
        return {
            objects: [],
            settings: {
                "initialBreak": "bottom",
                breaks: {
                    top: { "enabled": true, "height": 700 },
                    middle: { "enabled": false, "height": 400 },
                    bottom: { "enabled": true, "height": 240 },
                },
            },
            jsContentPanel: null,
            jsContentPanelItems: null,
            position: null,
            items: [],
            loading: true,
            visibleCard: false,
            loadingItem: null,
        };
    },
};
